/**
 * Created by wmh on 2019-12-5
 *
 * http请求配置文件
 * 基于axios针对业务进行封装
 * 包含拦截器等功能
 */

import axios from 'axios'

const host = window.npsApiUrl
// 测试token
const tokenObj = {
  token: 'f414260d7ae64860904cd34a363d53b4'
}

export const ajax = function ( config ) {
	//  默认请求方式get
	const method    = config.method || 'get';
	const url       = config.url;
	const headers   = config.headers || undefined;
	let data      = config.data || {};
	const isShowTip = config.isShowTip;

  data = Object.assign({}, data, tokenObj)

	//  返回请求promise对象
	return axios({
		// baseURL: tempHost,
		baseURL: host,
		method : method,
		url    : url,
		data   : method === 'post' ? data: undefined,
		params : method === 'get' ? data : undefined,
		headers: headers,
		isShowTip: isShowTip
	});
}
